module.exports = __webpack_public_path__ + "static/media/Avanade Color Logo RGB.d78e2108.png";